import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-digital-agency',
  templateUrl: './digital-agency.component.html',
  styleUrls: ['./digital-agency.component.scss']
})
export class DigitalAgencyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
